import { render, staticRenderFns } from "./GlavnaBocnaTraka.vue?vue&type=template&id=4d3cea5c&scoped=true"
import script from "./GlavnaBocnaTraka.vue?vue&type=script&lang=js"
export * from "./GlavnaBocnaTraka.vue?vue&type=script&lang=js"
import style0 from "./GlavnaBocnaTraka.vue?vue&type=style&index=0&id=4d3cea5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cea5c",
  null
  
)

export default component.exports